module.exports = __webpack_public_path__ + "static/img/yusbj1.6a6af1a5.png";